import { LogOutIcon, TypographyLogo, ChevronRightIcon } from '../../../assets/icons';
import { selectProfile, selectSideBarExpanded } from '../../../store/workspace/selectors';
import { useSelector, useDispatch } from '../../../store/store';
import { useNavigate, useLocation } from 'react-router-dom';
import { setLogOutModal } from '../../../store/auth/slice';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import {
    memberItems,
    ownerItems,
    SidebarItem
} from '../../../configs/sidebar';
import {
    setSideBarShow,
    setSideBarExpanded,
    setPlansModalShow,
    setContactAdminModal,
} from '../../../store/workspace/slice';

function SideBar(props: { show: boolean }) {
    const { show } = props;
    const navigate = useNavigate();
    const location = useLocation()
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const userProfile = useSelector(selectProfile);
    const sideBarExpanded = useSelector(selectSideBarExpanded);
    const [sidebarItems, setSidebarItems] = useState<SidebarItem[]>(memberItems);

    useEffect(() => {
        if (profile?.userRole === 'owner') {
            setSidebarItems(ownerItems);
        }
    }, [profile]);

    const itemClick = (path: string) => {
        switch (path) {
            case 'postjob': {
                postNewJob();
                break;
            }
            default: {
                navigate(path);
                dispatch(setSideBarShow(false));
                break
            }
        }
    };

    const postNewJob = () => {
        if (!userProfile) return;
        if (userProfile.postCounter === 0) {
            if (userProfile.userRole === 'owner') {
                dispatch(setPlansModalShow(true));
            } else {
                dispatch(setContactAdminModal(true));
            }
        } else {
            navigate('postjob');
        }
    };

    const toggleExpanded = () => {
        dispatch(setSideBarExpanded(!sideBarExpanded));
    };

    return (
        <div
            data-sidebar-open={show}
            className={styles.container}
            data-expanded={sideBarExpanded}
        >
            <div className={styles.header}>
                <TypographyLogo
                    width={121}
                    height={31}
                    className={styles.logo}
                />
                <button
                    onClick={toggleExpanded}
                    className={styles.toggleButton}
                    aria-label={sideBarExpanded ? 'Collapse sidebar' : 'Expand sidebar'}
                >
                    <ChevronRightIcon className={styles.toggleButton_icon} />
                </button>
            </div>

            {sidebarItems.map((item, indx) => (
                <>
                    <div
                        className={styles.item}
                        onClick={() => itemClick(item.path)}
                        data-selected={(!location.pathname.split('/')[2] && item.path === '') ||
                            location.pathname.split('/')[2] === item.path}
                    >
                        <img src={item.icon} alt='' />
                        <span className={styles.item_title}>{item.title}</span>
                        <span className={styles.item_tooltip}>{item.title}</span>
                    </div>
                    {indx === 5 && <hr />}
                </>
            ))}

            <div
                data-place-end="true"
                className={styles.item}
                onClick={() => dispatch(setLogOutModal(true))}
            >
                <LogOutIcon />
                <span className={styles.item_title}>Sign out</span>
                <span className={styles.item_tooltip}>Sign out</span>
            </div>
        </div>
    );
};

export default SideBar
